<template>
  <div>
    <Header />
    <div class="bg-[#18469d] p-5 text-white font-bold">
      <ul class="breadcrumb flex">
        <li
          v-for="(item, index) in b_value"
          :key="index"
          :class="{
            'breadcrumb-item': !isActive(index),
            'active-breadcrumb-item': isActive(index),
          }"
        >
          <span class="pl-2" :class="{ 'breadcrumb-text': !isActive(index) }">
            <a :href="item.link">{{ item.text }}</a>
          </span>
          <span v-if="index < b_value.length - 1" class="breadcrumb-arrow">
            >
          </span>
        </li>
      </ul>
    </div>
    <div class="w-full h-full p-5 lg:p-10 flex flex-col gap-5">
      <div class="w-full flex justify-between items-center">
        <h1 class="text-lg lg:text-2xl font-semibold dark_text">
          Attendance List
        </h1>
        <div class="flex flex-col gap-1">
          <p>Date : {{ current_date }}</p>
          <p>Day : {{ current_day }}</p>
        </div>
      </div>
      <div v-if="loading" class="flex items-center justify-center">
        <img src="@/assets/attendance/loading.gif" alt="" />
      </div>
      <div v-else class="w-full overflow-scroll">
        <table
          class="min-w-full border-collapse"
          v-if="attendance_list.length > 0"
        >
          <thead>
            <tr
              class="bg-[#18469d] text whitespace-nowrap text-sm"
              v-if="attendance_list.length && attendance_list[0].details"
            >
              <th class="px-6 py-3">Date</th>
              <!-- <th class="px-6 py-3">8.30AM - 9.25AM</th>
              <th class="px-6 py-3">9.25AM - 10.20AM</th>
              <th class="px-6 py-3">10.40AM - 11.35AM</th>
              <th class="px-6 py-3">11.35AM - 12.30PM</th>
              <th class="px-6 py-3">1.10PM - 2.05PM</th>
              <th class="px-6 py-3">2.05PM - 3.00PM</th>
              <th class="px-6 py-3">3.00PM - 3.55Pm</th> -->
              <th
                class="px-6 py-3"
                v-for="(detail, index) in this.attendance_list[0].details"
                :key="index"
              >
                {{ detail.session }}
              </th>
            </tr>
          </thead>
          <tbody v-if="attendance_list.length > 0">
            <tr
              v-for="list in attendance_list"
              :key="list"
              class="border border-[#afdaec] text-center whitespace-nowrap text-sm"
            >
              <td class="px-6 py-3 border border-gray-200">
                {{ list.date.split("-").reverse().join("-") }}
              </td>

              <td
                v-for="detail in list.details"
                :key="detail"
                class="px-6 py-3 border border-gray-200"
                :class="{
                  'bg-[#FFFFFF]': detail.class_status === '-',
                  'bg-[#FFFFFF]': detail.class_status === 'Upcoming',
                  'bg-[#e5e7eb]': detail.class_status === 'H',
                }"
              >
                <div class="flex flex-col gap-1">
                  <p v-if="detail.sub_code">{{ detail.sub_code }}</p>
                  <p>{{ detail.class_status }}</p>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="8" class="p-6 bg-[#18469d]"></td>
            </tr>
          </tfoot>
        </table>
        <div v-else class="flex justify-center">No Data Found</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import axios from "axios";

export default {
  data() {
    return {
      current_date: "",
      current_day: "",
      loading: true,
      attendance_list: [],
      b_value: [],
    };
  },
  components: { Header },
  created() {
    this.getattendance_list();
    const today = new Date();
    this.current_date = this.formatDate(today);
    this.current_day = this.getDayName(today);
    this.b_value = [
      { text: "Skool Lms", link: "/" },
      { text: "Attendance List", link: "/attendance-list" },
      { text: "Calender", link: "#" },
    ];
  },
  methods: {
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    filterList() {},
    async getattendance_list() {
      await axios
        .get(
          `${process.env.VUE_APP_API_COMS}/student/attendance/overall/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.attendance_list = response.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
            console.log("this.attendance_list", this.attendance_list);
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    getDayName(date) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days[date.getDay()];
    },
  },
};
</script>

<style></style>
